import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardTitle,
  CardText,
} from "reactstrap";
import moment from "moment";

import QuestionnaireModal from "./QuestionnaireModal";
import AppointmentCancelModal from "./AppointmentCancelModal";
import appointmentService from "../../services/appointmentService";

const Appointment = () => {
  const [appointments, setAppointments] = useState([]);

  useEffect(() => {
    appointmentService
      .getAttorneyAppointments()
      .then((payload) => setAppointments(payload));
  }, []);

  const refreshAppointments = () => {
    appointmentService
      .getAttorneyAppointments()
      .then((payload) => setAppointments(payload));
  };

  const getbackgroundColor = (status) => {
    //console.log(status, deleted);

    switch (status) {
      case 0:
        return "primary";
      case 1:
        return "primary";
      case 2:
        return "info";
      default:
        return "success";
    }
  };

  return (
    <React.Fragment>
      <Row>
        <Col xs={12}>
          <h1>Upcoming appointments</h1>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Row>
            <Col>
              <br />
            </Col>
          </Row>
          <Row>
            {appointments.map((a) => (
              <Col
                md={4}
                style={{ paddingBottom: "25px" }}
                key={a.appointmentId}
              >
                <Card
                  body
                  inverse
                  color={getbackgroundColor(a.appointmentStatus)}
                  style={{ height: "100%" }}
                >
                  <CardTitle
                    style={{ textAlign: "center", fontWeight: "bold" }}
                  >
                    {moment(a.timeSlotStart).format("MMMM Do YYYY, h:mm a")}
                  </CardTitle>
                  <CardText style={{ textAlign: "center" }}>
                    {(a.userId === "" || a.userId === "0") && (
                      <span>No litigant assigned</span>
                    )}

                    {a.userId !== "" && a.userId !== "0" && (
                      <React.Fragment>
                        <GetLitigant litId={a.userId} />
                        <QuestionnaireModal
                          buttonLabel="View Questionnaire"
                          color="white"
                          userId={a.userId}
                          qId={a.userQuestionnaireId}
                          hasCurrentQuestionnaire={true}
                          modalTitle="View Questionnaire"
                          readOnly={true}
                        />
                      </React.Fragment>
                    )}
                  </CardText>
                  {moment().isBefore(a.timeSlotStart) && (
                    <AppointmentCancelModal
                      type="Cancel"
                      appointmentId={a.appointmentId}
                      refreshAppointments={refreshAppointments}
                    />
                  )}
                  {moment().isSameOrAfter(a.timeSlotStart) && (
                    <AppointmentCancelModal
                      type="Complete"
                      refreshAppointments={refreshAppointments}
                    />
                  )}
                </Card>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </React.Fragment>
  );
};

const GetLitigant = (props) => {
  const id = { id: props.litId };
  const [litigant, setLitigant] = useState({});

  useEffect(() => {
    appointmentService.getLitigant(id).then((payload) => setLitigant(payload));
  }, [id]);

  return (
    <span>
      {litigant.lastName}, {litigant.firstName} <br />
      {moment(litigant.dob).format("MM/DD/YYYY")} <br />
      {litigant.userName}
    </span>
  );
};

export default Appointment;
